import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { getCookie, setCookie } from "@/lib/cookies";
import { Link } from "wouter";

const COOKIE_NAME = "drabpe_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const existing = getCookie(COOKIE_NAME);
    if (!existing) setVisible(true);
  }, []);

  if (!visible) return null;

  const handleChoice = (value: "accepted" | "declined") => {
    setCookie(COOKIE_NAME, value, 365);
    setVisible(false);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50">
      <div className="mx-auto max-w-4xl rounded-2xl border border-border bg-card/95 backdrop-blur shadow-xl p-4 md:p-5 flex flex-col md:flex-row md:items-center gap-3 md:gap-6">
        <div className="text-sm text-muted-foreground">
          We use cookies to improve site performance, remember preferences, and support location-based features.
          See our{" "}
          <Link href="/privacy" className="text-[#102026] font-semibold underline underline-offset-2">
            Privacy Policy
          </Link>.
        </div>
        <div className="flex gap-2 md:ml-auto">
          <Button variant="outline" onClick={() => handleChoice("declined")}>
            Decline
          </Button>
          <Button onClick={() => handleChoice("accepted")} style={{ backgroundColor: "#102026", color: "white" }}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}

